import React, { useState } from "react";
import check from "../check.svg";
import { TopMenuBar } from "../components/TopMenuBar/TopMenuBar";
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Button from "@mui/material/Button";
import NavBar from "../components/NavBar/NavBar";
import * as XLSX from "xlsx";

import * as Utils from "../Utils";

import "./style.css";

let tabCol = [];
let rows;
let numberOfTabs = 0;
let isu90tabCount = 0;
let flat463LtabCount = 0;
let c463LtabCount = 0;
let totalWeight = 0;
let totalWeights = [];

export const DonePage = (props) => {
  const [db] = useState(props.database);
  const [loading, setLoading] = React.useState(true);
  const [rowsCounter, setRowsCounter] = useState([]);

  async function handleCSV() {
    //change getAllItemsFromEditStore to getAllItemsFromPlaced after that is written
    await Utils.getAllItemsFromPlacedBoxes().then((result) => {
      downloadExcel(result);
    });
  }

  const downloadExcel = (data) => {
    // Define the exact worksheet columns in the required order.
    const columns = [
      "MAJCOM Code",
      "SRD",
      "SRAN",
      "Source of Supply",
      "National Stock Number (NSN)",
      "Noun / Nomenclature",
      "Detail Document Number",
      "Location",
      "CIC/CIIC",
      "Prime / Sub Flag",
      "Freeze Code",
      "Type Spares Code",
      "Allowance Source Code",
      "Authorized Qty",
      "On-Hand Qty",
      "Deployed Qty",
      "Deployed Code",
      "Deployed RID",
      "Unit Price",
      "Supportability Code",
      "Authorized Unsupportable Qty",
      "Date of Last Inventory (DOLI)",
      "PFMR Number",
      "Current FY",
      "Increment Code",
      "Unit Type Code (UTC)",
      "Kit Serial Number (KSN)",
      "Org Code",
      "Shop Code",
      "Due-Out Document Number",
      "D/O Qty",
      "TEX",
      "RDD",
      "Priority",
      "Project Code",
      "UJC",
      "Due-In Document Number",
      "D/I Status",
      "ESD",
      "DIFM Status",
      "# Short",
      "# Excess",
      "Alternate Storage Location",
      "ERRCD",
      "MDS",
      "Application Percent",
      "Withdrawal Flag",
      "Maintenance Repair Concept",
      "Note Code",
      "ISG Number",
      "Relationship Code",
      "MC Code",
      "Work Unit Code (WUC)",
      "IEX",
      "REX",
      "Shelf-Life Code",
      "Serialized Reporting Code (SRC)",
      "Hazardous Material Code",
      "Health Hazard Code",
      "Type Cargo Code",
      "Functional Check Flag",
      "Least Acceptable Item",
      "Date of Last Transaction (DOLT)",
      "Acquisition Advice Code (AAC)",
      "S05 Review Date",
      "Total Wartime Reqt Qty",
      "Kit Type",
      "Unit of Issue",
      "Item Identity Code",
      "Auth Number (POB)",
      "Budget Code",
    ];

    // Map source object fields to export column names.
    const fieldMap = {
      "National Stock Number (NSN)": "nsn",
      "Noun / Nomenclature": "name",
      Location: "location",
      "Authorized Qty": "authorizedqty",
      "On-Hand Qty": "qty",
      "Kit Serial Number (KSN)": "ksn",
      "Shop Code": "shopcode",
    };

    // Sanitize text to reduce spreadsheet formula injection risk.
    const sanitizeForExcel = (value) => {
      if (value === null || value === undefined) {
        return "";
      }

      const stringValue = String(value);

      if (/^[=+\-@]/.test(stringValue)) {
        return `'${stringValue}`;
      }

      return stringValue;
    };

    // Build data rows in the exact required order.
    const rows = (Array.isArray(data) ? data : []).map((item) => {
      const row = {};

      columns.forEach((columnName) => {
        const sourceField = fieldMap[columnName];
        row[columnName] = sourceField
          ? sanitizeForExcel(item[sourceField] ?? "")
          : "";
      });

      return row;
    });

    // Create worksheet from JSON rows.
    const worksheet = XLSX.utils.json_to_sheet(rows, {
      header: columns,
    });

    // Set readable column widths.
    worksheet["!cols"] = columns.map((columnName) => {
      switch (columnName) {
        case "National Stock Number (NSN)":
          return { wch: 24 };
        case "Noun / Nomenclature":
          return { wch: 32 };
        case "Location":
          return { wch: 20 };
        case "Kit Serial Number (KSN)":
          return { wch: 20 };
        case "Shop Code":
          return { wch: 12 };
        default:
          return { wch: Math.max(columnName.length + 2, 14) };
      }
    });

    // Create workbook and append sheet.
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Inventory");

    // Write workbook to an ArrayBuffer as a real XLSX file.
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Create a Blob using the official Excel MIME type.
    const fileData = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Force browser download as .xlsx.
    const fileName = "Job_R34.xlsx";
    const url = URL.createObjectURL(fileData);
    const link = document.createElement("a");

    link.href = url;
    link.download = fileName;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  };

  return (
    <div className="finalpacking">
      <TopMenuBar />
      <div className="under-banner">
        <div className="overlap-group-wrapper">
          <div className="frame-wrapper">
            <div className="frame-2">
              <div className="breadcrumb">
                <div className="breadcrumb-2">
                  <div className="button-2">
                    <button className="button-3">Upload File</button>
                    <CheckCircleIcon className="icons-2" />
                  </div>
                  <div className="button-4">
                    <div className="text-wrapper-2">Checklist</div>
                    <CheckCircleIcon className="icons-2" />
                  </div>
                  <div className="button-4">
                    <div className="text-wrapper-2">Pallets Required</div>
                    <CheckCircleIcon className="icons-2" />
                  </div>
                  <div className="button-4">
                    <div className="text-wrapper-2">Placement</div>
                    <CheckCircleIcon className="icons-2" />
                  </div>
                  <div className="button-5">
                    <div className="text-wrapper-3">3D Packing</div>
                    <SpaceDashboardIcon className="icons-3" />
                  </div>
                </div>
              </div>
              <div className="check-table">
                <img src={check} className="checkmark" alt="check" />
                <div className="div-3">
                  <p className="bold-discription">
                    Packing has been successfully completed!
                  </p>
                  <p className="discription">
                    To save a CSV version, click &#39;Save as CSV&#39;. If you
                    wish to send a new package, simply click &#39;Close&#39;,
                    and you will be redirected to the main page.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <NavBar>
            <button className="button-wrapper">
              <Button href="/" className="button-9">
                Close
              </Button>
            </button>
            <button className="button-7">
              <Button className="button-8" onClick={handleCSV}>
                Save R34
              </Button>
            </button>
          </NavBar>
        </div>
      </div>
    </div>
  );
};

export default DonePage;
